import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import handleComponentsProp from "./handleComponentsProp";
import DefaultLink from "./Link.jsx";
import parseStyle from "./parseStyle.js";
import useThemeProps from "./useThemeProps.jsx";

const DefaultDescription = styled("span", {
  shouldForwardProp: (prop) => prop !== "color",
})`
  ${({ theme, hidden }) => hidden && theme.styleUtils.visuallyHidden}
`;
const DefaultSeparator = styled("span", {
  shouldForwardProp: (prop) => prop !== "color",
})`
  color: ${({ theme, color }) => theme.getColor(color)};
  position: relative;
`;

export default function Breadcrumbs(props) {
  const theme = useTheme();
  props = useThemeProps({
    props,
    name: "Breadcrumbs",
  });
  let {
    label = "Breadcrumbs",
    description = "You are here:",
    hideDescription = false,
    items,
    fontSize = 3,
    separator = " / ",
    separatorColor = "gray.500",
    components,
    gap = 1,
    descriptionGap = 2,
    style = {},
    ...restProps
  } = props;

  let { Description, Separator, Link } = handleComponentsProp(components, {
    Description: DefaultDescription,
    Separator: DefaultSeparator,
    Link: DefaultLink,
  });

  if (typeof separator === "string") {
    separator = (
      <Separator aria-hidden="true" color={separatorColor}>
        {separator}
      </Separator>
    );
  }

  return (
    <nav
      aria-label={label}
      css={css`
        gap: ${theme.getLength(descriptionGap)};
        font-size: ${theme.getLength(fontSize)};
        ${parseStyle(style, theme)};
      `}
      {...restProps}
    >
      {description && (
        <Description hidden={hideDescription}>{description}</Description>
      )}{" "}
      <ol
        css={css`
          display: inline;
          margin: 0;
          padding: 0;
          list-style: none;
          gap: ${theme.getLength(gap)};
        `}
      >
        {items.map((item, index) => {
          return (
            <li
              key={index}
              css={css`
                display: inline;
                gap: ${theme.getLength(gap)};
              `}
            >
              {index !== 0 && separator}
              {index === items.length - 1 ? (
                <span aria-current="page">{item.label}</span>
              ) : item.url ? (
                <Link url={item.url}>{item.label}</Link>
              ) : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
